import React from 'react';
import { Spin } from 'antd';
import { PageWrapper } from '@/components';

interface PageLoadingProps {
  /** 加载提示文本 */
  tip?: string;
  /** 是否显示在PageWrapper中 */
  withPageWrapper?: boolean;
  /** 面包屑文本 */
  breadcrumb?: string;
  /** 页面标题 */
  title?: string;
  /** 自定义样式 */
  style?: React.CSSProperties;
  /** 加载图标大小 */
  size?: 'small' | 'default' | 'large';
}

const PageLoading: React.FC<PageLoadingProps> = ({
  tip = '加载中...',
  withPageWrapper = true,
  breadcrumb,
  title,
  style,
  size = 'large'
}) => {
  const loadingContent = (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        ...style
      }}
    >
      <Spin size={size} />
      <div style={{ marginTop: 16, color: '#666', fontSize: 14 }}>
        {tip}
      </div>
    </div>
  );

  if (withPageWrapper) {
    return (
      <PageWrapper breadcrumb={breadcrumb} title={title}>
        {loadingContent}
      </PageWrapper>
    );
  }

  return loadingContent;
};

export default PageLoading;
